import React from 'react';

export default function SoftwareOutsourcingIcon() {
  return (
    <svg width="26" height="22" viewBox="0 0 26 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M21.9703 13.4977L3.36084 14.5087L3.71349 21L22.323 19.989L21.9703 13.4977Z" fill="#FBB39E" />
      <path d="M24.0653 5.8361L2.55273 4L1.9999 10.4773L23.5125 12.3134L24.0653 5.8361Z" fill="#F66135" />
      <path d="M12.1732 16.312L7.63583 10.3284L17.5176 11.0368L12.1732 16.312Z" fill="#F66135" />
    </svg>
  );
}
